import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TemplateDeployment } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

const TemplateDeploymentsVersionCell = ({
  item: deployment,
  ...cellProps
}: TableSimpleCellProps<TemplateDeployment>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={deployment.templateVersion?.version} />
    </TableSimpleCell>
  );
};

export default TemplateDeploymentsVersionCell;
